import { render, staticRenderFns } from "./ShowMergingTwoNgos.vue?vue&type=template&id=755cbb34&"
import script from "./ShowMergingTwoNgos.vue?vue&type=script&lang=js&"
export * from "./ShowMergingTwoNgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports